import { Line } from "react-chartjs-2"
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, PointElement, LineElement } from "chart.js"
import { CustomChartType } from "../../types"
ChartJS.register(CategoryScale, LinearScale, BarElement, PointElement, LineElement, Title, Tooltip, Legend)

export default function ReminderPaymentCountChart(props: CustomChartType) {
    console.log(props.paymentStatistics)
    // Chart data
    const data = {
        labels: props.paymentStatistics?.map((item: any) => item.monthYear), // X-axis labels
        datasets: [
            {
                label: "Angeforderte Zahlungen",
                data: props.paymentStatistics?.map((item: any) => item.payreq_count),
                backgroundColor: "rgba(2, 163, 58, 0.6)", // Teal color
                borderColor: "rgba(2, 163, 58, 1)",
                pointRadius: 3,
                borderWidth: 1,
            },
            {
                label: "Offene Zahlungen",
                data: props.paymentStatistics?.map((item: any) => item.unpaid_payreq_count),
                backgroundColor: "rgba(5, 105, 168, 0.6)", // Teal color
                borderColor: "rgba(5, 105, 168, 1)",
                pointRadius: 3,
                borderWidth: 1,
            },
            {
                label: "Mahnungen",
                data: props.paymentStatistics?.map((item: any) => item.reminder_count),
                backgroundColor: "rgba(163, 15, 2, 0.6)", // Red color
                borderColor: "rgba(163, 15, 2, 1)",
                pointRadius: 3,
                borderWidth: 1,
            },
        ],
    }

    return (
        <div className="w-full grow bg-white rounded-default shadow-lg p-4 h-full">
            <Line
                className="grow h-full"
                data={data}
                options={{
                    responsive: true,
                    plugins: {
                        legend: {
                            position: "top",
                        },
                        title: {
                            display: true,
                            text: "Gesamte Zahlungsanforderungen & Mahnungen",
                        },
                    },
                    scales: {
                        y: {
                            beginAtZero: true,
                        },
                    },
                }}
            />
        </div>
    )
}
